module.exports = __webpack_public_path__ + "img/member_coupons_icon_431003.ccc3d329.jpg";